<div class="section">
    <div class="header">
        <div><mat-icon>keyboard_double_arrow_down</mat-icon><span>Month</span></div>
        <div *ngFor="let desc of alertDescriptions"><span>{{desc}}</span></div>
        <div><span>Closed</span></div>
        <div><span>Deferred</span></div>
        <div><span>Total</span></div>
    </div>
    <div *ngFor="let m of summaryResponse?.months; last as last" [ngClass]="{'border-b': !last}"
        >
        <div class="division-accordion">
            <div class="data-row">
                <div><span class="icon-align-centre" (click)="m.expand = !m.expand">
                    <mat-icon [class.expand-arrow]="true" [class.expanded]="m.expand">
                            {{ m.expand ? 'expand_less' : 'expand_more' }}
                        </mat-icon></span><span class="stat-value">
                        <div class="month-name">{{m.monthName}}</div>
                        <div class="report-count"> {{m.smryItems.length}} reports</div>
                    </span></div>
                <div *ngFor="let desc of alertDescriptions"><span>{{getMonthOpenCount(m, desc)}}</span></div>
                <div><span>{{zeroAsDash(m.closedCt.ct)}}</span></div>
                <div><span>{{zeroAsDash(m.deferredCt.ct)}}</span></div>
                <div><span>{{zeroAsDash(m.totalCt.ct)}}</span></div>
            </div>
            <div *ngIf="m.expand && m.smryItems && m.smryItems.length" class="w3-animate-opacity">
                <a class="accordian-row" *ngFor="let i of m.smryItems"
                   (click)="goToSupervisionReport(i.rptType, selectedYear, m.month, $event)">
                    <div title="{{i.rptDesc}}"><span class="m-l-10">{{i.rptDesc}}</span></div>
                    <div *ngFor="let desc of alertDescriptions"><a (click)="getOpenCount(i, desc) !== '--' ? goToSupervisionReport(i.rptType, selectedYear, m.month, $event, desc) : $event.stopPropagation()" [style.cursor]="getOpenCount(i, desc) !== '--' ? 'pointer' : 'default'" style="text-decoration:none"><span [style.color]="getAlertColor(i.rptType, desc, getOpenCount(i, desc))">{{getOpenCount(i, desc)}}</span></a></div>
                    <div (click)="zeroAsDash(i.closedCt) !== '--' ? goToSupervisionReport(i.rptType, selectedYear, m.month, $event, 'Closed') : $event.stopPropagation()" [style.cursor]="zeroAsDash(i.closedCt) === '--' ? 'default' : 'pointer'"><span>{{zeroAsDash(i.closedCt)}}</span></div>
                    <div (click)="zeroAsDash(i.deferredCt) !== '--' ? goToSupervisionReport(i.rptType, selectedYear, m.month, $event, 'Deferred') : $event.stopPropagation()" [style.cursor]="zeroAsDash(i.deferredCt) === '--' ? 'default' : 'pointer'"><span>{{zeroAsDash(i.deferredCt)}}</span></div>
                    <div (click)="zeroAsDash(i.totalCt) === '--' && $event.stopPropagation()" [style.cursor]="zeroAsDash(i.totalCt) === '--' ? 'default' : 'pointer'"><span>{{zeroAsDash(i.totalCt)}}</span></div>
                </a>
            </div>
        </div>
    </div>
</div>